import React from 'react';
import { Control, Controller, Path } from 'react-hook-form';
import { ChakraRadioGroup, ChakraRadioGroupProps } from 'app/components/Core';

interface ChakraFormRadioGroupProps<Form extends {}>
  extends Omit<ChakraRadioGroupProps, 'value'> {
  name: Path<Form>;
  control: Control<Form>;
}

export const ChakraFormRadioGroup = <Form extends {}>({
  name,
  control,
  ...rest
}: ChakraFormRadioGroupProps<Form>) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <ChakraRadioGroup {...rest} {...field} value={field.value as string} />
    )}
  />
);
